// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1ROJ_","messages":"Chat_messages__BvMmc","dateDivider":"Chat_dateDivider__3Cqi5"};